"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainHeaderPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pageStatePropTypes = require("./pageStatePropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MainHeaderPropTypes = exports.MainHeaderPropTypes = {
  logoImageUrl: _propTypes.default.string,
  logoHoverText: _propTypes.default.string,
  logoRedirectUrl: _propTypes.default.string,
  pageTitleText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  customContent: _propTypes.default.element,
  customCssClass: _propTypes.default.string,
  headerShouldPin: _propTypes.default.bool,
  contactDetails: _propTypes.default.element,
  children: _propTypes.default.node,
  showLogo: _propTypes.default.bool,
  headerNav: _propTypes.default.element,
  user: _pageStatePropTypes.UserPropTypes,
  customUserNav: _propTypes.default.element,
  isDialogPage: _propTypes.default.bool,
  onDialogClose: _propTypes.default.func,
  onLogout: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};